var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.created === false)?_c('button',{staticClass:"relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600",attrs:{"type":"button"},on:{"click":_vm.createSavedQuery}},[_c('span',[_vm._v("Save")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }